import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 根据查询条件获取点金列表
 * @param data
 */
export function getDianjinList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/DianJin/Api/List`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 获取点金详情
 * @param {number} setId 点金id
 */
export function getDianJinDetail(dianjinId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/DianJin/Api/Detail`,
    method: 'get',
    params: {
      id: dianjinId
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 获取点金视频的信息
 * @param {number} videoIdentity 视频id
 */
export function getPlayInfo(videoIdentity) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Resource/Api/PlayInfo`,
    method: 'get',
    params: {
      resourceIdentity: videoIdentity
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
/**
 * 大咖获取点金列表
 * @param data
 */
export function authorGetPageList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/PageList`,
    method: 'post',
    data,
    headers: {
      'Ykt-ViewState': viewState
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
/**
 * 大咖获取统计数据
 * @param data
 */
export function getAuthorStatistics() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/GetAuthorStatistics`,
    method: 'get'
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
/**
 * 大咖发布点金
 * @param data
 */
export function authorPublish(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/Publish`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 大咖点金详情
 * @param data
 */
export function authorGetDetail(id) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/GetDetail`,
    method: 'post',
    data: {
      id
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 大咖点金删除
 * @param id
 */
export function authorRemove(id) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/Remove`,
    method: 'post',
    data: {
      id
    }
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 大咖点金分页
 * @param data
 */
export function authorGetPage(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/getPage`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}

/**
 * 大咖点金收费资格申请
 * @param id
 */
export function feeApply(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/dianjin/Auth/ChargeApply`,
    method: 'post',
    data
  })
    .then(result => {
      return result
    })
    .catch(() => null)
}
